module.exports = __webpack_public_path__ + "static/img/invite-bg.8042f86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invite-bg.png
// module id = 8wdQ
// module chunks = 0